import { PageBase } from 'frontend/common-imports'
import { testEnv } from 'lib/env'
import conversionSet from 'frontend/lib/conversion/conversion-set'

export default class RoomPage extends PageBase {
  static handleDOMReady () {
    super.handleDOMReady()
    conversionSet.push({
      type: 'event', event: 'view_item', currency: 'USD', value: 1, items: [{ item_id: this.props.roomFriendlyId }],
    })
  }

  static get scheduleFallbackDelay () {
    return testEnv ? 100 : 3000
  }

  static get scheduleRoot () {
    return document.getElementById('room_schedule_react')
  }
}
